import React from "react";
import { useTranslation } from "react-i18next";

import { ILicenseRequestDetailPosition } from "~/pages/LicenseManagement/model/types";
import { formatMoney } from "~/shared/lib/formatMoney";
import { TableV2 } from "~/shared/ui/TableV2";

import s from "~/pages/LicenseManagement/LicenseManagement.less";

interface PositionsDetailTableProps {
  positions: ILicenseRequestDetailPosition[];
  totalCost: number;
}

const PositionsDetailTable = ({
  positions,
  totalCost,
}: PositionsDetailTableProps) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("licenseManagement.detail.position"),
      dataIndex: "positionName",
      key: "positionName",
      width: 360,
      render: (value: string) => value || "-",
    },
    {
      title: t("licenseManagement.detail.quantity"),
      dataIndex: "quantity",
      key: "quantity",
      width: 80,
      render: (value: number) => value ?? "-",
    },
    {
      title: t("licenseManagement.detail.unitPrice"),
      dataIndex: "unitPrice",
      key: "unitPrice",
      width: 100,
      render: (value?: number | null) => formatMoney(value),
    },
    {
      title: t("licenseManagement.detail.discountPercent"),
      dataIndex: "discountPercent",
      key: "discountPercent",
      width: 80,
      render: (value?: number | null) =>
        value === null || value === undefined ? "-" : value,
    },
    {
      title: t("licenseManagement.detail.discountAmount"),
      dataIndex: "discountAmount",
      key: "discountAmount",
      width: 80,
      render: (value?: number | null) =>
        value === null || value === undefined ? "-" : value,
    },
    {
      title: t("licenseManagement.detail.lineTotal"),
      dataIndex: "lineTotal",
      key: "lineTotal",
      width: 100,
      render: (value?: number | null) => formatMoney(value),
    },
  ];

  return (
    <div className={s.detailTableWrap}>
      <TableV2
        columns={columns}
        dataSource={positions.map((item) => ({
          ...item,
          id: item.positionId,
        }))}
        rowKey="id"
        pagination={false}
      />
      <div className={s.totalRow}>
        <span>{t("licenseManagement.detail.totalCost")}</span>
        <span>{formatMoney(totalCost)}</span>
      </div>
    </div>
  );
};

export default PositionsDetailTable;
